module.exports = __webpack_public_path__ + "img/crate_contents_power.d2b8f06a.png";